const notificationBell = {
  title: "Tilkynningar",
};

export default notificationBell;
